import { action } from "satcheljs";
import { IPreviewSchedulePageStore } from "../store/PreviewSchedulePageStore";

const initializePreviewSchedulePageStates = action("SETUP_PREVIEW_SCHEDULE_PAGE_STATE", (
    viewState: IPreviewSchedulePageStore
) => ({
    viewState: viewState
}));

export default initializePreviewSchedulePageStates;